import React from 'react';
import { Box, Typography } from '@mui/material';

const DOT_SX = {
  width: 8,
  height: 8,
  borderRadius: '50%',
  flexShrink: 0,
  mt: '5px',
};

/**
 * Source sync indicator — only shown when Auto sync controls are visible.
 */
const ListingSyncStatusRow = ({ connected = false, synced = false }) => {
  const isLive = synced && connected;
  const dotColor = isLive
    ? 'rgba(52,199,89,0.95)'
    : connected
      ? 'rgba(255,149,0,0.9)'
      : 'rgba(255,149,0,0.9)';

  let message = 'Waiting for the first update from your listing site.';
  if (isLive) {
    message = 'Status and dates stay in sync with your listing site.';
  } else if (connected) {
    message = 'Your listing site is connected — choose Auto sync above.';
  }

  return (
    <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1, mt: 1.25 }}>
      <Box
        sx={{
          ...DOT_SX,
          bgcolor: dotColor,
          boxShadow: isLive ? '0 0 0 3px rgba(52,199,89,0.15)' : 'none',
        }}
      />
      <Typography sx={{ fontSize: '0.78rem', color: 'rgba(0,0,0,0.58)', lineHeight: 1.45 }}>
        {message}
      </Typography>
    </Box>
  );
};

export default ListingSyncStatusRow;
